import styled from "styled-components";

const CourtWrapper = styled.div`
  /* margin-bottom: 1rem; */
  font-family: "Mark For MC Narrow W00 Light";
`;

const NoMatches = styled.p`
  text-align: center;
  color: #999;
  margin: 1rem 0;
`;

const CourtHeader = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ isOdd }) => (!isOdd ? "#000" : "#fff")};
  border-bottom: 1px solid #ddd;
`;

const CourtHeaderButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const CourtTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  color: ${({ isOdd }) => (!isOdd ? "#fff" : "#000")} !important;
`;

const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-between;
  margin: 1rem 0;
  font-family: "Mark For MC Narrow W00 Light";
`;

const TabButton = styled.button`
  font-family: "Mark For MC Narrow W00 Light";
  font-size: 1rem;
  background: ${({ active }) => (active ? "#e55300" : "#f5f5f5")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  border: none;
  padding: 0.5rem 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ active }) => (active ? "#d44700" : "#ddd")};
  }
`;

export {
  CourtWrapper,
  CourtHeader,
  CourtHeaderButton,
  CourtTitle,
  Tabs,
  TabButton,
  NoMatches
};
